import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")

    // Toggle between hamburger and X icon
    if (this.menuTarget.classList.contains("hidden")) {
      this.iconTarget.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      `
    } else {
      this.iconTarget.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      `
    }
  }
}
